import { render, staticRenderFns } from "./PaginaTabelleSogliePremiAddettiF100.vue?vue&type=template&id=3826cf3c&"
import script from "./PaginaTabelleSogliePremiAddettiF100.vue?vue&type=script&lang=js&"
export * from "./PaginaTabelleSogliePremiAddettiF100.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTabelleSogliePremiAddettiF100.vue?vue&type=style&index=0&id=3826cf3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports